import axios from "axios";
import { lockedApi, LAMBDA_URL } from "../api";
import IAuthHeaderConfig from "types/AuthHeaderConfig/IAuthHeaderConfig";
import { useApiAuthHeaderStore } from "@/stores/apiAuthHeaderStore";

export default () => {
  const apiAuthHeaderStore = useApiAuthHeaderStore();

  function setApiAuthorizationHeader(newHeader: IAuthHeaderConfig | string) {
    axios.interceptors.request.use((request) => {
      if (
        request.url != null &&
        !request.url.startsWith(LAMBDA_URL) &&
        request.url !== lockedApi.GIPHY_SEARCH &&
        !request.url.startsWith("https://vimeo.com/api/v2/video/")
      ) {
        if (typeof apiAuthHeaderStore.apiAuthorizationHeader === "string") {
          // @ts-expect-error
          request.headers["Authorization"] = newHeader;
        } else {
          for (const option in apiAuthHeaderStore.apiAuthorizationHeader) {
            if (typeof newHeader === "object" && newHeader[option] != null) {
              request.headers[option] = newHeader[option];
            } else {
              request.headers[option] =
                apiAuthHeaderStore.apiAuthorizationHeader[option];
            }
          }
        }
      }

      return request;
    });
  }

  return {
    setApiAuthorizationHeader,
  };
};
